import React from "react";
import { Fade } from "react-awesome-reveal";
import { Star } from "lucide-react";

const reviews = [
  {
    text: "For our anniversary this year I secretly made an appointment at Instant Iris.. He made the experience a blast and made our eyes look incredible. Im so happy with this, its going to look insane in our future living room",
  },
  {
    text: "Popped in to photograph my eye, was very excited to see how it went. Very surprised at how fast it was and there was no discomfort either! Done in an instant.",
  },
  {
    text: "Cool picture, and super service! Will be back. Fun to see all the details so well! It was a nice anniversary gift for me and my partner. Thank you again!",
  },
];

const StarRating = () => (
  <div className="flex justify-center gap-0.5" aria-label="5 out of 5 stars">
    {[...Array(5)].map((_, i) => (
      <Star
        key={i}
        className="h-3.5 w-3.5"
        fill="#b46800"
        color="#b46800"
        strokeWidth={1.5}
        aria-hidden="true"
      />
    ))}
  </div>
);

const ReviewCard = ({ text, delay = 0, isLast }) => (
  <Fade
    direction="up"
    delay={delay}
    triggerOnce
    className="flex h-full flex-1"
  >
    <article
      className={`flex h-full flex-1 flex-col items-center justify-center gap-3 px-4 text-center sm:px-6 md:px-10 ${
        !isLast ? "md:border-r md:border-main-dark/10" : ""
      }`}
    >
      <StarRating />
      <p className="font-copy text-[0.95rem] leading-relaxed text-main-dark md:text-base">
        <span className="text-iris-brown" aria-hidden="true">
          «
        </span>
        {text}
        <span className="text-iris-brown" aria-hidden="true">
          »
        </span>
      </p>
    </article>
  </Fade>
);

function Review() {
  return (
    <section className="pt-10 pb-8 md:pt-20 md:pb-16">
      <div className="container flex items-center">
        <div className="wrap w-full">
          <div className="flex flex-col gap-8 md:flex-row md:items-stretch md:gap-0">
            {reviews.map((review, index) => (
              <ReviewCard
                key={index}
                text={review.text}
                delay={index * 80}
                isLast={index === reviews.length - 1}
              />
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}

export default Review;
